"use client"

import { useFormik, FormikProvider } from "formik"
import { Loader2 } from "lucide-react"
import { Button } from "@/components/ui/button"
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog"
import { FormTextarea } from "@/components/form-inputs"
import { useProcessPayoutRequestMutation } from "@/hooks/mutations/partners"
import { useTranslations } from "next-intl"



export function RejectPayoutDialog({
  requestId,
  onOpenChange,
}: {
  requestId: string | null
  onOpenChange: (open: boolean) => void
}) {

  const tUi = useTranslations("Partners.PartnersAdminRejectPayoutDialog")

  const mutation = useProcessPayoutRequestMutation()

  const formik = useFormik<{ note: string }>({
    initialValues: { note: "" },
    validate: values => (values.note.trim() ? {} : { note: tUi("tellThePartnerWhy") }),
    onSubmit: async values => {
      if (!requestId) return
      try {
        await mutation.mutateAsync({ id: requestId, note: values.note.trim(), decision: "reject" })
        formik.resetForm()
        onOpenChange(false)
      } catch {
        // withQueryHandling already surfaced the error.
      }
    },
  })

  return (
    <Dialog open={Boolean(requestId)} onOpenChange={next => !mutation.isPending && onOpenChange(next)}>
      <DialogContent>
        <FormikProvider value={formik}>
          <form onSubmit={formik.handleSubmit}>
            <DialogHeader>
              <DialogTitle><span key={tUi("rejectPayoutRequest")}>{tUi("rejectPayoutRequest")}</span></DialogTitle>
              <DialogDescription><span key={tUi("theAmountReturnsToThePartnerSBalance")}>{tUi("theAmountReturnsToThePartnerSBalance")}</span></DialogDescription>
            </DialogHeader>
            <div className="py-5">
              <FormTextarea name="note" label={tUi("reason")} rows={3} maxLength={500} autoFocus />
            </div>
            <DialogFooter>
              <Button type="submit" variant="destructive" disabled={mutation.isPending}>
                {mutation.isPending && <Loader2 className="mr-1.5 h-4 w-4 animate-spin" />}
                <span key={tUi("rejectAndRefund")}>{tUi("rejectAndRefund")}</span></Button>
            </DialogFooter>
          </form>
        </FormikProvider>
      </DialogContent>
    </Dialog>
  )
}
